import Cookies from 'js-cookie';
import { flow } from 'mobx-state-tree';

import { getStores } from '../..';

export const removeMyLocation = flow(function* (self, poi) {
  const { config } = getStores(self, 'config');

  if (config.gysService.useMock) return;
  if (self.list.filter((x) => x.id === poi.id)?.length === 0) return;

  const locations =  Cookies.get('custom-pois');
  var myLocations = JSON.parse(locations);
  var removeIndexCookie = myLocations.map((x) => x.id).indexOf(poi.id);
  myLocations.splice(removeIndexCookie, 1);
  Cookies.set('custom-pois', JSON.stringify(myLocations));

  var removeIndex = self.list.map((x) => x.id).indexOf(poi.id);
  self.list.splice(removeIndex, 1);
});
